import React from 'react'
import { components, GroupBase, MenuListProps } from 'react-select'
import './CreateOptionMenu.css'

export type CreateNewConfig = {
  label: string
  /** Receives the text typed in the select, to prefill the name. */
  onCreate: (search: string) => void
}

function CreateMenuList<O, M extends boolean, G extends GroupBase<O>>(
  props: MenuListProps<O, M, G>
) {
  const createNew = (props.selectProps as unknown as { createNew?: CreateNewConfig }).createNew
  const search = props.selectProps.inputValue?.trim() || ''

  return (
    <components.MenuList {...props}>
      {props.children}
      {createNew ? (
        <div className="incyia-select-create">
          <button
            type="button"
            onMouseDown={(e) => {
              e.preventDefault()
              e.stopPropagation()
            }}
            onClick={() => {
              props.selectProps.onMenuClose()
              createNew.onCreate(search)
            }}
          >
            <span className="incyia-select-create-plus" aria-hidden>
              +
            </span>
            <span className="incyia-select-create-label">{createNew.label}</span>
            {search ? <span className="incyia-select-create-search">« {search} »</span> : null}
          </button>
        </div>
      ) : null}
    </components.MenuList>
  )
}

/**
 * Spread on a react-select to add a "+ New …" footer to the menu, shown both
 * under the options and in the empty state.
 */
export function createOptionProps(createNew?: CreateNewConfig): Record<string, unknown> {
  if (!createNew) return {}
  return { components: { MenuList: CreateMenuList }, createNew }
}
